import request from '@/utils/request'

// 登录方法
export function login(username, password, code, uuid) {
  const data = {
    username,
    password,
    code,
    uuid
  }
  return request({
    'url': '/login',
    headers: {
      isToken: false
    },
    'method': 'post',
    'data': data
  })
}

// 注册方法
export function register(data) {
  return request({
    url: '/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    'url': '/getInfo',
    'method': 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    'url': '/logout',
    'method': 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    'url': '/captchaImage',
    headers: {
      isToken: false
    },
    method: 'get',
    timeout: 20000
  })
}

// 获取企微免密登录地址
export function getSimpleRedirectUrl() {
  return request({
    'url': '/qw/js/getSimpleRedirectUrl',
    'method': 'get'
  })
}
// 获取企微免密登录地址
export function getRedirectUrl() {
  return request({
    'url': '/qw/js/getRedirectUrl',
    'method': 'get'
  })
}
// 通过企微免密登录账号
export function getAccessToken(query) {
  return request({
    'url': '/qw/js/getAccessToken',
    'method': 'get',
	'params': query
  })
}


// 注册方法
export function registerErpVip(data) {
  return request({
    url: '/user/ErpShopUser',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

export function sendMessSmsCheckCode(query) {
  return request({
    url: '/mess/detail/job/sendMessSmsCheckCode',
    // headers: {
    //   isToken: false
    // },
    method: 'post',
	params: query
  })
}
export function registerUserAccount(data) {
  return request({
    url: '/user/ErpShopUser/registerUserAccount',
    method: 'post',
    data: data
  })
}
export function getQrConnectUrl(query) {
  return request({
    url: '/MortinErp/mp/wx/portal/'+query.appid+'/getQrConnectUrl',
    headers: {
      isToken: false
    },
    method: 'post',
	params: query
  })
}
export function mpLogin(query) {
  return request({
    url: '/MortinErp/mp/wx/portal/'+query.appid+'/mpLogin',
    headers: {
      isToken: false
    },
    method: 'get',
	params: query
  })
}